import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { logout } from '../../../redux/actions'

const Content = ({contentAsProp}) => {

    const dispatch = useDispatch();
    let user = useSelector((state) => state.userDetails.user);
    return (
        <div className="mainContentWrapper vh-100">
            <div className="user-bar d-flex justify-content-end align-items-center">
                <div className="logged-user-snap">
                    <img className="img-fluid" src={user.image ? `${process.env.REACT_APP_SERVER_URL}/images/${user.image}` : `${process.env.REACT_APP_URL}/static/images/profile-info.png`} alt="" />
                </div>
                <span className="logged-user-name">{user.firstname}</span>
                <span className="logout-icon"  onClick={() => { dispatch(logout()); }}>
                    <i className="fa fa-power-off"></i>
                </span>
            </div>
            {contentAsProp}
        </div> 
    )
}

export default Content
